import React, { useCallback, useState } from 'react'
import NumberFormat from 'react-number-format'
import moment from 'moment'
import { RECEIPTS_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import QuickLinkService from '../../services/quick-link.service'

export default function PaymentReceipts({ dataSource = [] }) {
  const [expanded, setExpanded] = useState(null)
  const { t } = useTranslation()

  const getDownload = useCallback(async (selected) => {
    try {
      const reqParams = {
        transRefNum: selected.transactionRef,
        refId: selected.receiptId,
        module: 'BILLPAYMENT',
      }
      await QuickLinkService.pdfReceipt(reqParams)
    } catch (err) {}
  }, [])

  return (
    <>
      <div style={{ justifyContent: ' space-between', alignItems: 'center' }}>
        {dataSource.map((item, index) => (
          <div
            key={index}
            className='loan-card '
            onClick={() => (expanded === index ? setExpanded(null) : setExpanded(index))}>
            <div className='loan-header'>
              <div>
                <span>
                  {t(RECEIPTS_KEYS.REF_ID)} : {item.transactionRef}
                </span>
                <div style={{ display: 'flex' }}>
                  <span>{t(RECEIPTS_KEYS.TRANSACTION_DATE)} : </span>
                  <span style={{ marginLeft: 5 }}>
                    {moment(item.transTime).format('DD-MM-YYYY')} &nbsp;{''}
                    {moment(item.transTime).format('HH:MM:SS')}
                  </span>
                </div>
              </div>
              <div>
                <div className='d-flex' style={{ justifyContent: 'end' }}>
                  <label style={{ fontSize: '6px' }}>{item?.srcAccCcy}</label>
                  &nbsp;
                  <NumberFormat
                    value={item?.amount}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={''}
                    className='float-right'
                    fixedDecimalScale={true}
                    decimalScale={2}
                    allowEmptyFormatting
                  />
                </div>
                <div>
                  <span>
                    {t(RECEIPTS_KEYS.SERVICE_NO)} : {item.serviceNumber}
                  </span>
                </div>
              </div>
            </div>
            {expanded === index && (
              <div className='loan-details'>
                <div className='row beneficiary-details justify-space-between '>
                  <div className='col-12'>
                    <div className='row'>
                      <div className='col-4'>
                        <div className='label'>{t(RECEIPTS_KEYS.FROM_ACCOUNT)}</div>
                        <div className='value'>{item?.srcAccount}</div>
                      </div>

                      {/* <div className='col-4'>
                          <div className='label'>{t(RECEIPTS_KEYS.TO_ACCOUNT)}</div>
                          <div className='value'>{item?.destAccount}</div>
                        </div> */}

                      <div className='col-4'>
                        <div className='label'>{t(RECEIPTS_KEYS.TRANSACTION_DATE)}</div>
                        <div className='value'>
                          {moment(item.transTime || '-').format('DD-MM-YYYY')} &nbsp;{' '}
                          {moment(item.transTime || '-').format('HH:MM:SS')}
                        </div>
                      </div>

                      <div className='col-4'>
                        <div className='label'>{t(RECEIPTS_KEYS.TRANS_CURRENCY)}</div>
                        <div className='value'>{item?.srcAccCcy}</div>
                      </div>

                      <div className='col-4'>
                        <div className='label'>{t(RECEIPTS_KEYS.SERVICE_NO)}</div>
                        <div className='d-flex value'>{item?.serviceNumber}</div>
                      </div>
                      <div className='col-4'>
                        <div className='label'>{t(RECEIPTS_KEYS.AMOUNT)}</div>
                        <div className='d-flex value'>
                          <NumberFormat
                            value={item?.amount}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={''}
                            fixedDecimalScale={true}
                            decimalScale={2}
                            allowEmptyFormatting
                          />
                        </div>
                      </div>
                      <div className='col-4'>
                        <div className='label'>{t(RECEIPTS_KEYS.REMARKS)}</div>
                        <div className='value'>{item?.remarks}</div>
                      </div>
                    </div>

                    <div class='row'>
                      <h6
                        className='download-link'
                        onClick={(e) => {
                          e.preventDefault()
                          e.stopPropagation()
                          getDownload(item)
                        }}>
                        {t(RECEIPTS_KEYS.DOWNLOAD)}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  )
}
